import React from 'react';

const NewAbout = () => {
  return (
    <section id="about" className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Image */}
          <div className="relative h-[300px] sm:h-[400px] md:h-[500px] rounded-lg overflow-hidden shadow-2xl order-2 lg:order-1">
            <img
              src="https://images.pexels.com/photos/7587734/pexels-photo-7587734.jpeg?w=800&auto=compress"
              alt="Evershine Tiling"
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              About Evershine Services
            </h2>
            <div className="w-16 sm:w-24 h-1 bg-blue-600 mb-4 sm:mb-6"></div>
            <div className="space-y-3 sm:space-y-4 text-base sm:text-lg text-gray-700 leading-relaxed">
              <p>
                Evershine Services provides reliable and professional tiling services across Brisbane, Gold Coast, and Sunshine Coast. Our commitment to excellence ensures that every project receives the highest standard of workmanship.
              </p>
              <p>
                We take pride in our attention to detail and focus on quality that stands the test of time. Whether it's a small renovation or a large commercial project, our experienced team delivers results that exceed expectations.
              </p>
              <p>
                With years of industry experience, we've built a reputation for customer satisfaction and delivering long-lasting results. Our dedication to using high-quality materials and proven techniques ensures your investment is protected.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewAbout;